import React from "react";
import { Navigate } from "react-router-dom";

// Small helper to render a permanent redirect entry inside React Router.
// Replaces the URL client-side so subsequent history entries point to the
// canonical destination. Search engines eventually pick up the new URL from
// the sitemap and internal links.
const RedirectTo = ({ to }) => <Navigate to={to} replace />;

export default RedirectTo;
